module.exports = __webpack_public_path__ + "static/media/furniture.560b3091.jpg";